import type { FC } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "../common/form/useForm";
import { Modal, useModal } from "../common/modal/Modal";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { useCompanyActions } from "../company/useCompany";
import { Button } from "../components/Button";

export const ModalCreateCompany: FC = () => {
	const { createCompany } = useCompanyActions();
	const { mutateAsync, isPending } = createCompany;
	const { close } = useModal();

	const form = useForm({
		initialValues: {
			name: "",
		},
		onSubmit: async (values) => {
			await mutateAsync(values);
			close();
		},
	});

	return (
		<Modal size="lg">
			<h2>Create a new company</h2>

			<Form onSubmit={form.handleSubmit}>
				<ExtraForm.Group label="Name" required>
					<ExtraForm.Control
						placeholder="Company Name"
						data-testid="create-company-name"
						{...form.getFieldProps("name")}
						{...form.getFieldState("name")}
					/>
				</ExtraForm.Group>

				<Button full variant="primary" loading={isPending} type="submit">
					Create
				</Button>
			</Form>
		</Modal>
	);
};
